
import { defineComponent, reactive, toRefs, onMounted, onUnmounted } from "vue";
import { KEYMAP, NUMBER_PAD, PART_TWO } from "./keymap";

export default defineComponent({
  name: "Keyboard",
  setup(props, context) {
    const state = reactive({
      keys: KEYMAP,
      part2Keys: PART_TWO,
      numPadKey: NUMBER_PAD,
      keyState: new Set<string>(),
      pressed: new Set<string>(),
    });
    const onKeyDown = (e: KeyboardEvent) => {
      // console.log("keydown", e);
      e.preventDefault();
      e.stopPropagation();
      state.keyState.add(e.code);
      state.pressed.add(e.code);
      context.emit("lastkeyPressed", {
        code: e.code,
        key: e.key,
        keyCode: e.keyCode,
      });
      return true;
    };
    const onKeyUp = (e: KeyboardEvent) => {
      e.preventDefault();
      e.stopPropagation();
      console.log("keyup", e.code);
      state.keyState.delete(e.code);
      if (e.code === "MetaLeft" || e.code === "MetaRight") {
        state.keyState.clear();
      }
      return true;
    };
    onMounted(() => {
      document.onkeyup = onKeyUp;
      document.onkeydown = onKeyDown;
    });
    onUnmounted(() => {
      // document.removeEventListener("keydown", onKeyDown);
      // document.removeEventListener("keyup", onKeyUp);
    });
    return {
      ...toRefs(state),
      onKeyDown,
      onKeyUp,
    };
  },
});
